// Camada de API da tela de permissões (planilha de acesso + editor de grupos).
// Contrato fechado pelo backend desta entrega (RBAC v2) — ver
// .claude/rbac/arquitetura-v2.md §5-6 e o resumo passado pelo orquestrador.
// Não inventar rotas fora daqui: qualquer campo que falte no retorno é
// tratado como ausente pelos componentes de frontend/src/components/access.
import authFetch from '../utils/authFetch';

const BASE = '/api/v1';

// ---- Grupos de permissão (roles) ------------------------------------------

export function fetchRoles() {
  return authFetch(`${BASE}/roles`);
}

export function fetchCapabilities() {
  return authFetch(`${BASE}/roles/capabilities`);
}

export function createRole(payload) {
  return authFetch(`${BASE}/roles`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function updateRole(id, payload) {
  return authFetch(`${BASE}/roles/${id}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
}

export function deleteRole(id) {
  return authFetch(`${BASE}/roles/${id}`, { method: 'DELETE' });
}

// ---- Planilha de acesso -----------------------------------------------------

export function fetchAccessUsers({ search = '', limit = 25, offset = 0 } = {}) {
  const qs = new URLSearchParams();
  if (search) qs.set('search', search);
  qs.set('limit', String(limit));
  qs.set('offset', String(offset));
  return authFetch(`${BASE}/access/users?${qs.toString()}`);
}

export function fetchUserBoards(userId) {
  return authFetch(`${BASE}/access/users/${userId}/boards`);
}

export function setUserRole(userId, roleId) {
  return authFetch(`${BASE}/access/users/${userId}/role`, {
    method: 'PUT',
    body: JSON.stringify({ role_id: roleId }),
  });
}

export function setUserWorkspaceLevel(userId, workspaceId, level) {
  return authFetch(`${BASE}/access/users/${userId}/workspaces/${workspaceId}`, {
    method: 'PUT',
    body: JSON.stringify({ level }),
  });
}

export function removeUserWorkspaceLevel(userId, workspaceId) {
  return authFetch(`${BASE}/access/users/${userId}/workspaces/${workspaceId}`, {
    method: 'DELETE',
  });
}

export function setUserBoardLevel(userId, boardId, level) {
  return authFetch(`${BASE}/access/users/${userId}/boards/${boardId}`, {
    method: 'PUT',
    body: JSON.stringify({ level }),
  });
}

export function removeUserBoardLevel(userId, boardId) {
  return authFetch(`${BASE}/access/users/${userId}/boards/${boardId}`, {
    method: 'DELETE',
  });
}

// ---- Áreas de trabalho -------------------------------------------------------
// Reaproveita a rota já existente (dona: boardStore/sidebar). Só leitura,
// usada aqui para popular os seletores de área do popover e do editor de grupo.

export function fetchWorkspacesList() {
  return authFetch(`${BASE}/workspaces`);
}
